import React from "react";
import { useHistory } from "react-router-dom";
import { RouteNames } from "routes/routes";
import Button from "components/button";
import ContainerFlex from "components/ContainerFlex";
import * as St from "./styles";
import TermsPrivacyCard from "components/termsPrivacyCard";

const TermoPrivacidadePDF: React.FC = () => {
  const history = useHistory();

  const handleVoltar = () => {
    history.push(RouteNames.TERMO_E_CONDICOES);
  };

  return (
    <ContainerFlex center flex={1} horizontal>
      <ContainerFlex center>
        <St.Title>Ler a política de privacidade</St.Title>
      </ContainerFlex>

      <ContainerFlex center padding={15}>
        <TermsPrivacyCard />
      </ContainerFlex>

      <ContainerFlex center marginTop={-10}>
        <ContainerFlex row horizontal>
          <ContainerFlex>
            <Button onClick={handleVoltar} size="large" outlined>
              <span>Voltar</span>
            </Button>
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default TermoPrivacidadePDF;
